import { depthToAmbient } from "../physics/pressure.js";
import type { PlannedSegment } from "../types.js";

export interface TankSpec {
  volume: number;
  startPressure: number;
}

export interface ConsumptionInput {
  sac: number;
  tank: TankSpec;
}

export interface SegmentConsumption {
  litersAtSurface: number;
  cumulativeLiters: number;
  tankPressureBefore: number;
  tankPressureAfter: number;
}

export function litersForSegment(
  startDepth: number,
  endDepth: number,
  duration: number,
  sac: number,
): number {
  if (duration <= 0) return 0;
  const pAmbAvg = (depthToAmbient(startDepth) + depthToAmbient(endDepth)) / 2;
  return sac * pAmbAvg * duration;
}

export function tankPressureFromLiters(
  litersConsumed: number,
  tank: TankSpec,
): number {
  const startLiters = tank.volume * tank.startPressure;
  const remaining = startLiters - litersConsumed;
  return remaining / tank.volume;
}

export function consumptionForSegments(
  segments: PlannedSegment[],
  input: ConsumptionInput,
): SegmentConsumption[] {
  const out: SegmentConsumption[] = [];
  let cumulative = 0;
  for (const seg of segments) {
    const liters = litersForSegment(seg.startDepth, seg.endDepth, seg.duration, input.sac);
    const before = tankPressureFromLiters(cumulative, input.tank);
    cumulative += liters;
    const after = tankPressureFromLiters(cumulative, input.tank);
    out.push({
      litersAtSurface: liters,
      cumulativeLiters: cumulative,
      tankPressureBefore: before,
      tankPressureAfter: after,
    });
  }
  return out;
}

export function totalConsumption(
  segments: PlannedSegment[],
  sac: number,
): number {
  let total = 0;
  for (const seg of segments) {
    total += litersForSegment(seg.startDepth, seg.endDepth, seg.duration, sac);
  }
  return total;
}
